import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 0;

  h1 {
    margin: 0 0 3% 5%;
    font-size: 20px;
    font-weight: 500;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  margin: 0 4%;
  margin-bottom: 5%;
  font-size: 20px;
  font-weight: normal;
`;

export const Image = styled.img`
  width: 20%;
  padding: 0;
  margin-right: 5%;
  @media (max-width: 800px) {
    width: 40%;
  }
`;
